<!--
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-03-25 16:43:24
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\components\map.vue
 * @
 -->
<template>
<!-- 百度地图取经纬度，已废弃。 -->
    <div style="width: 100%;height: 8rem" @click="activeBtn">
        <baidu-map class="map" :center="map" :zoom="17" :scroll-wheel-zoom="true" style="border: 1px solid #c8ced3"
                   @click="mapLoad">
            <!--放大缩小控件-->
            <!--<bm-navigation></bm-navigation>-->
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                            :autoLocation="true"></bm-geolocation>
            <!--定位-->
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                            :autoLocation="true"></bm-geolocation>
            <!--搜索组件-->
            <bm-marker :position="{lng: usermap.lng, lat: usermap.lat}">
            </bm-marker>
            <bm-control style="width: 100%">
                <el-input size="mini" style="width: 100%" v-model="map" property="输入地区"></el-input>
            </bm-control>
        </baidu-map>
    </div>
</template>

<script>
    export default {
        // props:['lat','lng'],
        data() {
            return {
                map: '北京',
                zoom: null,
                usermap: {
                    lat: 116.403829,
                    lng: 39.915158,
                    address: '',
                    addressComponents: {}
                }
            }
        },
        methods: {
            mapLoad(e) {
                this.usermap.lat = e.point.lat
                this.usermap.lng = e.point.lng
                this.zoom = e.target.getZoom()
                let geocoder = new BMap.Geocoder();  //创建地址解析器的实例
                geocoder.getLocation(e.point, rs => {
                    this.usermap.address = rs.address
                    this.usermap.addressComponents = rs.addressComponents
                })
                console.log(this.usermap)
            },
            activeBtn() {
                this.$emit("callFather")
            }
        },
        watch: {
            usermap: {
                handler(val, oldval) {
                    this.activeBtn()
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .map {
        width: 100%;
        height: 8rem;
        margin: 0 auto;
    }
</style>
